import type { Dict } from "./pl.js";

export const de: Dict = {
  navCats: "Kategorien",
  navHow: "So funktioniert es",
  navOps: "Für Betriebe",
  navPrice: "Preise",
  navContact: "Kontakt",
  navBook: "Demo des Betriebspanels",
  pill: "Die Buchungsplattform für Dienstleistungsbetriebe",
  title1: "Ihre Leistungen.",
  title2: "Buchen sich selbst.",
  sub: "b00k führt alle Ihre Leistungskalender — Zimmer, Fahrzeuge, Termine — in einem Buchungssystem zusammen. Kundinnen und Kunden buchen selbst über Web und Chat, das System wacht über die Termine und blockiert Überschneidungen.",
  ctaBook: "Betriebskonto anlegen",
  ctaOperator: "Kundenansicht ansehen",
  heroMeta: "IHRE-FIRMA.B00K.ONLINE · JEDER BETRIEB ERHÄLT EINE EIGENE SUBDOMAIN",
  cardChip: "Bestätigt",
  cardNote: "Buchungen laufen von allein ein — aus Web und Chat — und sperren den Plan sofort.",
  catsKick: "LEISTUNGSKATEGORIEN",
  catsTitle: "Was Sie mit b00k abwickeln",
  catsSub: "Eine Plattform für alle Ihre Leistungen. Zeitgebundene laufen nacheinander, Zimmer und Fahrzeuge werden parallel für ganze Tage gebucht.",
  cat1t: "Zimmer",
  cat1d: "Zimmer und Apartments für eine oder mehrere Nächte. Mehrere Zimmer lassen sich für denselben Zeitraum parallel buchen.",
  cat2t: "Fahrzeuge",
  cat2d: "Stadtautos und SUVs tageweise. Der Verfügbarkeitskalender wacht über Ausgabe und Rückgabe.",
  cat3t: "Freizeit",
  cat3d: "Sauna, Spa, Kajaks. Buchung zu einer festen Uhrzeit mit fester Dauer.",
  cat4t: "Friseur",
  cat4d: "Schnitt und Farbe. Sie wählen die Uhrzeit — das System sperrt genau so lange, wie die Leistung dauert.",
  cat5t: "Kosmetik",
  cat5d: "Maniküre und Massage. Mit anderen Leistungen kombinierbar — die Dauern verschmelzen zu einem Block.",
  cat6t: "Medizin",
  cat6d: "Beratung und Untersuchung zur festen Uhrzeit. Der Praxiskalender hält sich selbst in Ordnung.",
  cat7t: "Werkstatt",
  cat7d: "Auto, Fahrrad oder Notebook — wir decken alles ab.",
  cat8t: "Nachhilfe",
  cat8d: "Sprachunterricht oder Klavierstunde — führen Sie es auf unserer Plattform.",
  cat9t: "Sonstiges",
  cat9d: "Die Besonderheiten Ihrer Branche + unsere Erfahrung = Erfolg.",
  howKick: "SO FUNKTIONIERT ES",
  howTitle: "Drei Schritte, null Telefonate",
  s1t: "Leistungen und Ressourcen anlegen",
  s1d: "Zimmer, Fahrzeuge und Termine mit Dauer und Preis erfassen. Das System prüft jedes Konto bei der Anmeldung — Ihres und das Ihrer Kundschaft.",
  s2t: "Kunden buchen selbst",
  s2d: "Über Web oder Chat — WhatsApp und Messenger. Dauern addieren sich, Zimmer werden parallel gebucht, und angezeigt wird nur, was wirklich frei ist.",
  s3t: "Das System wacht über den Plan",
  s3d: "Mit der Bestätigung ist der Termin gesperrt — zwei Personen können dieselbe Leistung nie zur selben Zeit buchen. Stornierungen und Umbuchungen inklusive.",
  newChip: "Neu",
  chatLine: "Ihre Kundschaft kann im Chat buchen — über WhatsApp oder Messenger.",
  opsKick: "FÜR BETRIEBE",
  opsTitle: "Ihr Kalender arbeitet für Sie",
  opsSub: "Zimmer, Fahrzeuge und Termine in einem Kalender. Überschneidungen werden automatisch blockiert, Chat-Buchungen laufen von allein ein, und Auslastung wie Umsatz sehen Sie in Echtzeit.",
  opsCta: "Betriebspanel ansehen",
  f1: "Tageskalender und Ressourcenauslastung in einer Ansicht",
  f2: "Automatische Sperre bei Terminkonflikten",
  f3: "Buchungen aus Web und Chat — WhatsApp / Messenger",
  f4: "Kunden, Notizen zur Buchung und Kennzahlen",
  priceKick: "PREISE",
  priceTitle: "So einfach wie eine Buchung",
  month: "Mon.",
  recommended: "Empfohlen",
  soon: "DEMNÄCHST VERFÜGBAR",
  custom: "Individuell",
  opsSuffix: "Mitarbeitende",
  priceNote: "Der Monatspreis richtet sich danach, wie viele Mitarbeitende Zugang zum Panel haben.",
  t1f1: "Kalender und Online-Buchungen",
  t1f2: "WhatsApp- / Messenger-Chat",
  t1f3: "Kunden, Notizen und Erinnerungen",
  t2f1: "Alles aus SOLO",
  t2f2: "Ressourcen und Leistungen ohne Limit",
  t2f3: "Berichte und Auslastungskennzahlen",
  t3f1: "Alles aus TEAM",
  t3f2: "Dienstpläne und Rollen der Mitarbeitenden",
  t3f3: "API und Integrationen",
  t4f1: "Alles aus GROUP",
  t4f2: "Einführungsbegleitung und SLA",
  t4f3: "Individueller Vertrag und Abrechnung",
  conKick: "KONTAKT & ANFAHRT",
  conTitle: "Ihr Standort, ihre Anfahrt",
  dirKick: "ANFAHRT — SO SEHEN SIE IHRE KUNDEN",
  dir1: "Mit dem Auto: Nationalstraße 3 aus Jelenia Góra, Ausfahrt Szklarska Poręba Centrum, dann 5 Minuten über die Zdrojowa.",
  dir2: "Mit der Bahn: Bahnhof Szklarska Poręba Górna, 12 Minuten Fußweg Richtung Zentrum.",
  dir3: "Gästeparkplatz vor Ort — kostenlos, ohne Reservierung.",
  footUser: "Kundenansicht",
  footOp: "Betriebspanel",

  wizTitle: "Betriebskonto anlegen",
  wizSub: "Sieben Schritte. Am Ende haben Sie eine eigene Subdomain und ein einsatzbereites Panel.",
  wizStep1: "Firma",
  wizStep2: "Subdomain",
  wizStep3: "Branchen",
  wizStep4: "Tarif",
  wizStep5: "Administrator",
  wizStep6: "Zahlungen",
  wizStep7: "Zusammenfassung",
  wizNext: "Weiter",
  wizBack: "Zurück",
  wizFinish: "Konto anlegen",
  fCompany: "FIRMENNAME",
  fNip: "STEUERNUMMER (NIP)",
  fPhone: "TELEFON",
  fAddress: "ANSCHRIFT",
  fSlug: "SUBDOMAIN",
  slugHint: "Die Adresse, unter der Ihre Kundschaft bei Ihnen bucht.",
  slugChecking: "Verfügbarkeit wird geprüft…",
  slugFree: "Die Subdomain ist frei.",
  slugTaken: "Diese Subdomain ist bereits vergeben.",
  slugInvalid: "Subdomain: 3–63 Zeichen, Kleinbuchstaben, Ziffern und Bindestrich (nicht am Anfang oder Ende).",
  industriesHint: "Wählen Sie die Branchen, die Sie bedienen. Weitere können Sie jederzeit im Panel ergänzen.",
  planHint: "Den Tarif ändern Sie jederzeit — ohne Datenverlust.",
  fName: "VOR- UND NACHNAME",
  fEmail: "E-MAIL",
  fPass: "PASSWORT (MIND. 8 ZEICHEN)",
  fPass2: "PASSWORT WIEDERHOLEN",
  fTerms: "Ich akzeptiere die Bedingungen von b00k.online und willige in die Datenverarbeitung zur Abwicklung von Buchungen ein.",
  payTitle: "Kundenzahlungen",
  payHint: "Optional. Sie können Online-Zahlungen bei der Bestätigung einer Buchung annehmen.",
  payEnable: "Online-Zahlungen annehmen",
  payMethods: "ZAHLUNGSARTEN",
  sumTitle: "Zusammenfassung",
  sumCompany: "FIRMA",
  sumSub: "SUBDOMAIN",
  sumIndustries: "BRANCHEN",
  sumPlan: "TARIF",
  sumAdmin: "ADMINISTRATOR",
  sumPayments: "ZAHLUNGEN",
  yes: "Ja",
  no: "Nein",
  doneTitle: "Das Betriebskonto steht",
  doneSub: "Ihre Subdomain ist online. Melden Sie sich im Panel an und legen Sie Leistungen an — Buchungen starten sofort.",
  doneOpen: "Betriebspanel öffnen",
  doneBooking: "Buchungsseite ansehen",
  companyProofOk: "Angemeldet als Firmenadministrator:",
  companyLoginOther: "Mit einem anderen Konto anmelden",
  errGeneric: "Das Konto konnte nicht angelegt werden. Prüfen Sie die Daten und versuchen Sie es erneut.",
};
